import { render } from "./Appointments.vue?vue&type=template&id=91f64efe&scoped=true"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=91f64efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f64efe"]])

export default __exports__